import clsx from "clsx";
import { Children } from "react";
const ColumnLayout = ({
	children,
	withPaddingTop = false,
	disableMobileYSpace = false,
	noXPadding = false,
	className = "",
}) => {
	return (
		<div
			className={clsx(
				"ColumnLayout",
				"flex flex-col lg:flex-row",
				"max-w-screen-xl mx-auto",
				"px-5 lg:px-0",
				//"gap-10",
				{ "space-y-7.5 lg:space-y-0": !disableMobileYSpace },
				{ "pt-20": withPaddingTop },
				className
			)}
		>
			{children}
		</div>
	);
};

const SingleColumn = ({ children, className = "" }) => {
	return (
		<div
			className={clsx(
				"ColumnLayout__single",
				"w-full mx-auto",
				"lg:px-5",
				"flex flex-col xl:items-center",
				className
			)}
		>
			{children}
		</div>
	);
};

const MainColumn = ({ noXPadding = false, children, className = "" }) => {
	return (
		<div
			className={clsx(
				"ColumnLayout__main",
				"lg:w-2/3",
				{ "lg:px-5": !noXPadding },
				className
			)}
		>
			{children}
		</div>
	);
};

const SidebarColumn = ({ children, className = "" }) => {
	return (
		<div
			className={clsx(
				"ColumnLayout__sidebar",
				"lg:w-1/3",
				"lg:px-5 lg:ml-auto relative",
				className
			)}
		>
			<div
				className={clsx(
					"ColumnLayout__sidebarItems",
					"space-y-7.5",
					"lg:sticky lg:top-0 lg:h-full"
				)}
			>
				{Children.map(children, (child, index) => {
					return (
						<div
							key={index}
							className={clsx("ColumnLayout__sidebarItem", {
								"h-full": Children.count(children) === 1,
							})}
						>
							{child}
						</div>
					);
				})}
			</div>
		</div>
	);
};

ColumnLayout.SingleColumn = SingleColumn;
ColumnLayout.MainColumn = MainColumn;
ColumnLayout.SidebarColumn = SidebarColumn;

export default ColumnLayout;
